import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const GhostShape = ({ width, height, fillColor, style }: BaseSVGType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M31.751 0.0112422C18.4095 0.411145 8.125 12.0502 8.125 25.3968V58.9023C8.125 60.7126 10.3124 61.6178 11.5921 60.3381L14.7558 57.9857C15.6013 57.3572 16.787 57.4791 17.4865 58.2662L22.9392 64.4044C23.7326 65.1979 25.0187 65.1979 25.8121 64.4044L30.9816 58.5836C31.7903 57.6734 33.2109 57.6734 34.0184 58.5836L39.1879 64.4044C39.9813 65.1979 41.2674 65.1979 42.0608 64.4044L47.5135 58.2662C48.213 57.4791 49.3987 57.356 50.2442 57.9857L53.4079 60.3381C54.6876 61.6178 56.875 60.7113 56.875 58.9023V24.3748C56.875 10.6639 45.5546 -0.402625 31.751 0.0112422ZM24.375 28.4373C22.1317 28.4373 20.3125 26.6181 20.3125 24.3748C20.3125 22.1316 22.1317 20.3123 24.375 20.3123C26.6183 20.3123 28.4375 22.1316 28.4375 24.3748C28.4375 26.6181 26.6183 28.4373 24.375 28.4373ZM40.625 28.4373C38.3817 28.4373 36.5625 26.6181 36.5625 24.3748C36.5625 22.1316 38.3817 20.3123 40.625 20.3123C42.8683 20.3123 44.6875 22.1316 44.6875 24.3748C44.6875 26.6181 42.8683 28.4373 40.625 28.4373Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default GhostShape;
